module.exports = __webpack_public_path__ + "img/distant-river.4dd08acb.svg";